import { cn } from "@newxsystems/shared";
import { WohaCardLink } from "../../../../modules/content/components/WohaCardLink/WohaCardLink";
import { WohaCommonContent } from "../../../../modules/content/components/WohaCommonContent/WohaCommonContent";
import { WohaRichText } from "../../../../modules/content/components/WohaRichText/WohaRichText";
import { WohaSection } from "../../../../modules/content/components/WohaSection/WohaSection";
import type { ITextContentGridBlockProps } from "./TextContentGridBlock.props";
const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;
const spans = {
  1: "lg:col-span-1",
  2: "lg:col-span-2",
  3: "lg:col-span-3",
  4: "lg:col-span-4",
} as const;
export const TextContentGridBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: ITextContentGridBlockProps) => {
  if (!items?.length) return null;
  return (
    <WohaSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-12">
        <WohaCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className={cn("grid grid-cols-1 gap-4 sm:grid-cols-2", columns[columnCount || 3])}>
          {items.map((item, index) => (
            <WohaCardLink
              className={cn(
                "min-h-44 rounded-xl border border-ash bg-white p-6",
                spans[item.columnSpan || 1],
              )}
              key={index}
              link={item.cardLink}
            >
              <div className="mb-6 h-1 w-10 rounded-full bg-electric-blue transition-[width] duration-300 ease-out group-hover:w-20" />
              <h3 className="font-satoshi text-2xl font-medium leading-tight text-charcoal">
                {item.heading}
              </h3>
              {item.description ? (
                <WohaRichText
                  className="mt-4 text-base leading-7 text-steel"
                  content={item.description}
                />
              ) : null}
            </WohaCardLink>
          ))}
        </div>
      </div>
    </WohaSection>
  );
};
TextContentGridBlock.displayName = "Block::TextContentGridBlock";
